import api from "../lib/api";

/**
 * Retrieve the latest currency rate record from backend.
 * Returns `null` if none exist or the request fails.
 */
export const fetchLatestRates = async () => {
  try {
    const res = await api.get("/currencies");

    if (res.data && res.data.length > 0) {
      const raw = res.data[0];
      // console.log("Fetched latest currency rates", raw);

      // normalize strings to numbers
      return {
        ...raw,
        aedRate: Number(raw.aedRate),
        iqdRate: Number(raw.iqdRate),
      };
    }
  } catch (err) {
    console.error("fetchLatestRates error", err);
  }

  return null;
};
